module.exports = __webpack_public_path__ + "static/media/jeep-lwb-side.396273bf.jpg";